/* Footer: desktop-open accordions, locale auto-submit, wordmark reveal */
(() => {
  const mq = window.matchMedia('(min-width: 990px)');
  const cols = [...document.querySelectorAll('[data-ft-col]')];
  const sync = () => cols.forEach(d => { d.open = mq.matches; });
  sync();
  mq.addEventListener?.('change', sync);

  const locale = document.getElementById('FooterLocale');
  locale?.querySelector('select')?.addEventListener('change', () => locale.submit());

  const mark = document.querySelector('[data-ft-mark]');
  if (!mark) return;
  if (!('IntersectionObserver' in window)) { mark.classList.add('is-revealed'); return; }
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { mark.classList.add('is-revealed'); io.disconnect(); }
    });
  }, { threshold: 0.35 });
  io.observe(mark);
})();
